import React from 'react';
import classNames from 'classnames';
import viewStates from '../../../helpers/viewStates';
import useNavigation from '../../../hooks/useNavigation';
import { useTranslation } from 'react-i18next';
import CustomText from './CustomText';
import MessageList from './MessageList';

const ChatArea = () => {
  const { t } = useTranslation();
  const { view, reset, initialMessage, backActive } = useNavigation();

  const renderScrollableArea = () => {
    if (!initialMessage) {
      return;
    }

    return <MessageList initialMessage={initialMessage} />;
  };

  return (
    <div id="chat-area" className={classNames({
      visible: view !== viewStates.START,
    })}>

      <div id="button-wrapper">
        <button type="button" className={classNames({
          button: true,
          block: true,
          reverse: true,
          active: backActive
        })} onClick={reset}>
          {t('header.back_to_questions')}
        </button>
      </div>
      <div id="scrollable-area">
        {renderScrollableArea()}
      </div>
    </div>
  );
};

export default ChatArea;
